import App from './App.vue'

function install(Vue) {
  function promoteDialog(params) {
    return new Promise((resolve, reject) => {
      const Constructor_ = Vue.extend(App)
      const dialog = new Constructor_({
        el: document.createElement('div')
      })
      dialog.resolve = resolve
      dialog.reject = reject

      for (let key in params) {
        dialog[key] = params[key]
      }

      document.body.appendChild(dialog.$el)
    })
  }

  Vue.prototype.$promoteDialog = promoteDialog
}

export default { install }



// WEBPACK FOOTER //
// ./src/ui/components/promoteDialog/index.js